const theme = {
  palette: {
    primary: {
      light: '#8d6eff',
      main: '#4F41F2',
      dark: '#0014be',
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: '#abb2ce',
      main: '#7c839d',
      dark: '#4f566f',
      contrastText: '#000000',
    },
  },
  typography: {
    fontFamily: 'Open Sans, sans-serif',
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        fontFamily: 'Open Sans, sans-serif',
      },
    },
  },
};

export default theme;
